import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const CanIBorrowComponent = props => {
    const { data, labels, setView } = props;
    const { t } = useTranslation();

    const getHasAvailableCollectionsBlock = useMemo(() => {
        // eslint-disable-next-line react/display-name
        return () => {
            const { sim_existem_acervos } = labels;
            const { total_exemplares_disponiveis } = data;
            if (typeof sim_existem_acervos === 'string') {
                const parts = sim_existem_acervos.split('{qtd_acervos}');
                if (parts?.length) {
                    return (
                        <>
                            <span className="s18 f700">{parts[0]}</span>
                            <span className="f900 mx-2 verde s30">
                                {total_exemplares_disponiveis}
                            </span>
                            <span className="s18 f700">{parts[1]}</span>
                        </>
                    );
                }
            }
            return null;
        };
    }, [labels, data]);

    if (data === null || labels === null) return null;

    const {
        pode_emprestar,
        pode_reservar,
        total_exemplares_disponiveis,
        num_dias_voltar,
    } = data;

    const {
        posso_emprestar,
        quando_volta,
        estimativa_volta,
        quer_reservar,
        botao_reservar,
    } = labels;

    const handleClickBookReservation = () => {
        setView('reservation');
    };

    return (
        <>
            <span className="s16 f400 d-block mt-3">{posso_emprestar}</span>
            {pode_emprestar === 'S' && total_exemplares_disponiveis > 0 ? (
                <div className="align-self-center">
                    {getHasAvailableCollectionsBlock()}
                </div>
            ) : (
                <>
                    <span className="s18 f700 d-block">
                        {labels.nao_pode_emprestar}
                    </span>
                    {num_dias_voltar !== null &&
                    parseInt(num_dias_voltar) !== -1 &&
                    !num_dias_voltar.isNaN ? (
                        <>
                            <span className="s16 f400 d-block mt-3">
                                {quando_volta}
                            </span>
                            <span className="s18 f700 d-block">
                                {parseInt(num_dias_voltar) === 0
                                    ? t('DevolucaoAtrasada')
                                    : estimativa_volta?.replace(
                                          '{qtd_dias}',
                                          num_dias_voltar,
                                      )}
                            </span>
                        </>
                    ) : (
                        ''
                    )}

                    {pode_reservar === 'S' ? (
                        <>
                            <span className="s16 f400 d-block mt-3">
                                {quer_reservar}
                            </span>
                            <button
                                onClick={handleClickBookReservation}
                                type="submit"
                                className="b-solid b-teen3 b-w3 bkazul branco h-teen hover hpreto px-3 rad20 s14 sazul f500"
                            >
                                <FontAwesomeIcon
                                    icon="ticket-alt"
                                    className="mr-1 fa-fw"
                                />
                                <span>{botao_reservar}</span>
                            </button>
                        </>
                    ) : (
                        ''
                    )}
                </>
            )}
        </>
    );
};

export default CanIBorrowComponent;
